<app-dialog-container
    [loading]="false"
    (closeEvent)="onClose()"
>
    <div class="is-flex align-center justify-center break-newline has-text-centered">{{ data.text }}</div>
    <div
        *ngIf="data.warningText && !data.toggleProperty?.Value"
        class="is-flex align-center justify-center break-newline has-text-centered"
    >
        {{ data.warningText }}
    </div>
    <div
        *ngIf="data.toggleProperty"
        class="is-flex align-center justify-center"
    >
        <app-filter-input [property]="data.toggleProperty"></app-filter-input>
    </div>
    <br />
    <div class="level is-full-width">
        <app-button
            *ngIf="data.showCancel"
            [class]="'level-item'"
            [buttonText]="data.cancelText"
            (buttonClick)="onCancel()"
            [type]="'stroked'"
        />
        <app-button
            [class]="'level-item'"
            [buttonText]="data.confirmText"
            (buttonClick)="onConfirm()"
            [color]="data.destructiveConfirm ? 'danger' : 'primary'"
            [type]="'flat'"
        />
        <app-button
            [class]="'level-item'"
            [buttonText]="data.denyText"
            (buttonClick)="onDeny()"
            [type]="'flat'"
            [color]="data.destructiveConfirm ? 'primary' : 'danger'"
        />
    </div>
</app-dialog-container>
